export default [
  {
    icon: "edit",
    label: "Edit Details",
    method: "updateMember"
  },
  {
    icon: "edit",
    label: "Change Password",
    method: "changePassword"
  },
  {
    icon: "Deactivate",
    label: "Deactivate",
    method: "deleteMember"
  }
];
